// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__yqy_8","logo":"Logo_logo__3uuF2","subscript":"Logo_subscript__3E3DS","secondhalf":"Logo_secondhalf__3OEDs"};